import { TypographyHeading } from "shared/molecules/typography-layout";
import { ProductsFilter } from "./filter";
import { Box, InputLabel, Paper, Typography, FormControl, Select, MenuItem, Pagination } from "@mui/material";
import Loader from "pages/build-test/loader";
import SectionTable from "shared/organisms/tables/table";
import { useEffect, useState } from "react";
import { GET_PRODUCTS_LIST } from "utils/graphql/services/live-classes/queries";
import { useLazyQuery } from "@apollo/client";
import entitesClient from "utils/graphql/entitiesClient";
import NoDataFound from "shared/molecules/no-data";
import {Stack} from "@mui/material"
import {table} from "./helper"
import liveClassClientService from "utils/graphql/liveclassClient";
import { utcToIst } from "utils/time-util/utcIstTime";


export default function Products() {

    const [searchPayload, setSearchPayload] = useState({});
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const INTIAL_LIMIT= 50;
    
    const [getProductsList, { loading, error, data }] = useLazyQuery(
        GET_PRODUCTS_LIST,
        {
            client: liveClassClientService,
        },
    );

    useEffect(() => {
        getProductsList({
            variables: {
                input: {
                    limit: limit,
                    offset: (page - 1) * limit,
                    ...searchPayload,
                },
            },
        });
    }, [page, limit, searchPayload]);

    const productsData =
            data?.getProducts?.products?.map((item: any) => ({
                ...item,
                createdAt: utcToIst(item.createdAt),
                updatedAt: utcToIst(item.updatedAt),
            })) || [];

    return (
        <>
            <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
                Products{" "}
            </TypographyHeading>
            {/* {console.log(data)} */}
            <ProductsFilter
                setSearchPayload={setSearchPayload}
                setPage={setPage}
            />

            <Paper elevation={2} sx={{ p: 2, mt: 3 }}>

                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                    <FormControl size="small" sx={{ width: 140 }}>
                        <InputLabel>Show Entries</InputLabel>
                        <Select
                            value={limit}
                            label="Show Entries"
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setPage(1); // reset to first page
                            }}
                        >
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                            <MenuItem value={500}>500</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <div>
                    {loading && <Loader />}
                    {!loading && data?.getProducts?.products?.length > 0 ? (
                        <SectionTable
                            data={productsData || []}
                            table={table}
                            id="id"
                            name="id"
                            rowsPerPageCount={limit}
                            style="false"
                            totalRecords={data?.getProducts?.totalCount || 0}
                            paginationSegment="false"
                            viewSecondaryData="false"
                        />
                    ) : (
                        <div>{!loading && <NoDataFound message="No Data Found" />}</div>
                    )}
                </div>

                <Box sx={{ marginTop: "20px" }}>
                    <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Pagination
                            count={Math.ceil(data?.getProducts?.totalCount / limit) || 1}
                            page={page}
                            onChange={(e, value) => setPage(value)}
                            color="primary"
                            size="medium"
                        />
                    </Stack>
                </Box>

            </Paper>
        </>
    )
}